/* Generated File DO NOT EDIT. */
/* tslint:disable */
import * as Types from '../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMessagesQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int'];
}>;

export type GetMessagesQuery = {
  __typename?: 'Query';
  notifications: Array<{
    __typename?: 'Notification';
    _id: string;
    scheduledAt?: any | null;
    readAt?: any | null;
    messageId?: string | null;
    message?: { __typename?: 'Message'; _id: string; title?: string | null; body: string } | null;
  }>;
};

export type GetNotificationsQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int'];
}>;

export type GetNotificationsQuery = {
  __typename?: 'Query';
  notifications: Array<{
    __typename?: 'Notification';
    _id: string;
    type: Types.NotificationType;
    messageId?: string | null;
    scheduledAt?: any | null;
    title?: string | null;
    body?: string | null;
    message?: { __typename?: 'Message'; title?: string | null; body: string } | null;
  }>;
};

export type GetMessageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type GetMessageQuery = {
  __typename?: 'Query';
  notification: {
    __typename?: 'Notification';
    _id: string;
    scheduledAt?: any | null;
    readAt?: any | null;
    messageId?: string | null;
    message?: { __typename?: 'Message'; _id: string; title?: string | null; body: string } | null;
  };
};

export type GetUnreadMessageCountQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetUnreadMessageCountQuery = { __typename?: 'Query'; getUnreadCount: number };

export type MarkNotificationAsReadMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;

export type MarkNotificationAsReadMutation = { __typename?: 'Mutation'; markNotificationAsRead: boolean };

export type MarkNotificationsAsRegisteredMutationVariables = Types.Exact<{
  notificationIds: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;

export type MarkNotificationsAsRegisteredMutation = { __typename?: 'Mutation'; markNotificationsAsRegistered: Array<boolean> };

export const GetMessagesDocument = gql`
  query getMessages($offset: Int!) {
    notifications(type: MESSAGE, offset: $offset) {
      _id
      scheduledAt
      readAt
      messageId
      message {
        _id
        title
        body
      }
    }
  }
`;

/**
 * __useGetMessagesQuery__
 *
 * To run a query within a React component, call `useGetMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, options);
}
export function useGetMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, options);
}
export type GetMessagesQueryHookResult = ReturnType<typeof useGetMessagesQuery>;
export type GetMessagesLazyQueryHookResult = ReturnType<typeof useGetMessagesLazyQuery>;
export type GetMessagesQueryResult = Apollo.QueryResult<GetMessagesQuery, GetMessagesQueryVariables>;
export const GetNotificationsDocument = gql`
  query getNotifications($offset: Int!) {
    notifications(offset: $offset) {
      _id
      type
      messageId
      message {
        title
        body
      }
      scheduledAt
      title
      body
    }
  }
`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
}
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
}
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetMessageDocument = gql`
  query getMessage($id: ID!) {
    notification(id: $id) {
      _id
      scheduledAt
      readAt
      messageId
      message {
        _id
        title
        body
      }
    }
  }
`;

/**
 * __useGetMessageQuery__
 *
 * To run a query within a React component, call `useGetMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMessageQuery(baseOptions: Apollo.QueryHookOptions<GetMessageQuery, GetMessageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, options);
}
export function useGetMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageQuery, GetMessageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, options);
}
export type GetMessageQueryHookResult = ReturnType<typeof useGetMessageQuery>;
export type GetMessageLazyQueryHookResult = ReturnType<typeof useGetMessageLazyQuery>;
export type GetMessageQueryResult = Apollo.QueryResult<GetMessageQuery, GetMessageQueryVariables>;
export const GetUnreadMessageCountDocument = gql`
  query getUnreadMessageCount {
    getUnreadCount(type: MESSAGE)
  }
`;

/**
 * __useGetUnreadMessageCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadMessageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadMessageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadMessageCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadMessageCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUnreadMessageCountQuery, GetUnreadMessageCountQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUnreadMessageCountQuery, GetUnreadMessageCountQueryVariables>(GetUnreadMessageCountDocument, options);
}
export function useGetUnreadMessageCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadMessageCountQuery, GetUnreadMessageCountQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUnreadMessageCountQuery, GetUnreadMessageCountQueryVariables>(GetUnreadMessageCountDocument, options);
}
export type GetUnreadMessageCountQueryHookResult = ReturnType<typeof useGetUnreadMessageCountQuery>;
export type GetUnreadMessageCountLazyQueryHookResult = ReturnType<typeof useGetUnreadMessageCountLazyQuery>;
export type GetUnreadMessageCountQueryResult = Apollo.QueryResult<GetUnreadMessageCountQuery, GetUnreadMessageCountQueryVariables>;
export const MarkNotificationAsReadDocument = gql`
  mutation markNotificationAsRead($id: String!) {
    markNotificationAsRead(notificationId: $id)
  }
`;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
}
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkNotificationsAsRegisteredDocument = gql`
  mutation markNotificationsAsRegistered($notificationIds: [String!]!) {
    markNotificationsAsRegistered(notificationIds: $notificationIds)
  }
`;
export type MarkNotificationsAsRegisteredMutationFn = Apollo.MutationFunction<MarkNotificationsAsRegisteredMutation, MarkNotificationsAsRegisteredMutationVariables>;

/**
 * __useMarkNotificationsAsRegisteredMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsRegisteredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsRegisteredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsRegisteredMutation, { data, loading, error }] = useMarkNotificationsAsRegisteredMutation({
 *   variables: {
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useMarkNotificationsAsRegisteredMutation(
  baseOptions?: Apollo.MutationHookOptions<MarkNotificationsAsRegisteredMutation, MarkNotificationsAsRegisteredMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkNotificationsAsRegisteredMutation, MarkNotificationsAsRegisteredMutationVariables>(MarkNotificationsAsRegisteredDocument, options);
}
export type MarkNotificationsAsRegisteredMutationHookResult = ReturnType<typeof useMarkNotificationsAsRegisteredMutation>;
export type MarkNotificationsAsRegisteredMutationResult = Apollo.MutationResult<MarkNotificationsAsRegisteredMutation>;
export type MarkNotificationsAsRegisteredMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsAsRegisteredMutation, MarkNotificationsAsRegisteredMutationVariables>;
